import { OffersPromoRepository } from "../Repository/OffersPromoRepository";

export interface UpdateStateModalUseCase {
    invoke: (modalId: number) => Promise<boolean>;
  }
  
  export class UpdateStateModal implements UpdateStateModalUseCase {
    private Repo: OffersPromoRepository;
    constructor(_Repo: OffersPromoRepository) {
      this.Repo = _Repo;
    }
  
    async invoke(modalId: number){
       
        if(modalId <= 0){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const update  = await this.Repo.updateStateModal(modalId);
        return update;
    }
  }